export default {
    currentQuestion(state) {
        return state.currentQuestion;
    },
    questions(state) {
        return state.questions;
    },
};